(function (){
    'use strict';

    angular
        .module('services')
        .factory('Payee', Payee);

    /* @ngInject */
    function Payee ($http, API_BASE) {
        /* Static methods and properties */
        Payee.create = create;
        Payee.where = where;
        Payee.destroy = destroy;
        Payee.API_RESOURCE = `${API_BASE}/payees`;
        Payee.API_OPTIONS = { header: { 'Content-Type': 'application/json; charset=UTF-8' } };

        /* Instance methods */
        Payee.prototype.fill = fill;
        Payee.prototype.save = save;
        Payee.prototype.update = update;

        /* Constructor */
        return Payee;

        /* Implementation details */ 
        function Payee(data) {
            this.name = null;
            
            if (data !== undefined) {
                this.fill(data);
            }
        }

        function create(data) {
            let payee = new Payee(data);

            payee.save();

            return payee;
        }
        
        function save() {
            return $http.post(Payee.API_RESOURCE, this, Payee.API_OPTIONS)
                .then(res => new Payee(res.data));
        }

        function fill(data) {
            for (let attr in data) {
                this[attr] = data[attr]; 
            }
            return this;
        }

        function update(data) {
            this.fill(data);
            return $http.post(`${Payee.API_RESOURCE}/${this.id}`, this, Payee.API_OPTIONS)
                .then(res => new Payee(res.data));
        }

        function destroy(id) {
            return $http.delete(`${Payee.API_RESOURCE}/${id}`, { ...Payee.API_OPTIONS });
        }

        function where(query) {
            return $http.get(Payee.API_RESOURCE, {
                    ...Payee.API_OPTIONS, 
                    params: query
                });
            }
    }
})();